module.exports = __webpack_public_path__ + "tag.jpg?94a80c9e4c8776de89103220ae864a7f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/tag.jpg
// module id = 156
// module chunks = 0